import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { Router, Route } from '@angular/router';
import { CMSService } from '../Services/cms.service';
import { NavMenuComponent } from '../nav-menu/nav-menu.component';
import { Bind } from 'primeng/bind';
import { Tabs, TabPanels, TabPanel } from 'primeng/tabs';

@Component({
    selector: 'app-travel-insurance',
    templateUrl: './travel-insurance.component.html',
    styleUrls: ['./travel-insurance.component.css'],
    imports: [NavMenuComponent, Bind, Tabs, TabPanels, TabPanel]
})
export class TravelInsuranceComponent implements OnInit {

  @ViewChild('target') private myScrollContainer: ElementRef;
  constructor(public cmsService: CMSService, public router: Router) { }
  insuranceRights: any;
  ngOnInit() {
    this.insuranceRights = JSON.parse(localStorage.getItem("InsuranceRights"));
  }
   //(click) = "routeToIssue()"
  routeToIssue() {
    this.router.navigateByUrl("insurance-issuance");
  }
  routeToBooked(id:string) {
    this.router.navigate(["search-booked-plan", id]);
  }
  routeToCancel() {
    this.router.navigateByUrl("cancel-insurance-policy");
  }
  routeToUnitedIssue() {
    this.router.navigateByUrl("united-travel-insurance");
  }
}
